export default __webpack_public_path__ + "rule.61bfe6d4353b6d66.svg";